import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelDynamic as _vModelDynamic, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["aria-busy"]
const _hoisted_2 = { class: "mhtk-login__header" }
const _hoisted_3 = {
  class: "mhtk-login__title",
  "data-test-ref": "member-login-title"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "mhtk-login__dropdown"
}
const _hoisted_6 = ["id", "aria-expanded"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "fa-solid fa-caret-down",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_8 = ["aria-labelledby"]
const _hoisted_9 = {
  key: 0,
  role: "presentation"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "fa-solid fa-arrow-up-right-from-square",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_12 = {
  key: 1,
  role: "presentation"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "fa-solid fa-arrow-up-right-from-square",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_15 = {
  key: 2,
  role: "presentation"
}
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  class: "fa-solid fa-arrow-up-right-from-square",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_18 = ["data-test-ref"]
const _hoisted_19 = ["href"]
const _hoisted_20 = ["href"]
const _hoisted_21 = ["href"]
const _hoisted_22 = {
  key: 1,
  class: "mhtk-login__form-field"
}
const _hoisted_23 = ["for"]
const _hoisted_24 = ["id"]
const _hoisted_25 = ["value"]
const _hoisted_26 = {
  key: 2,
  class: "mhtk-login__form-field"
}
const _hoisted_27 = ["for"]
const _hoisted_28 = ["id"]
const _hoisted_29 = ["value"]
const _hoisted_30 = ["for"]
const _hoisted_31 = ["id", "placeholder", "aria-invalid"]
const _hoisted_32 = { class: "mhtk-login__form-field-link" }
const _hoisted_33 = ["href"]
const _hoisted_34 = ["for"]
const _hoisted_35 = { class: "mhtk-login__input-group" }
const _hoisted_36 = ["id", "type", "placeholder", "aria-invalid"]
const _hoisted_37 = ["aria-label"]
const _hoisted_38 = { class: "mhtk-login__form-field-link" }
const _hoisted_39 = ["href"]
const _hoisted_40 = {
  type: "submit",
  class: "mhtk-login__submit-button",
  "data-test-ref": "member-login-button"
}
const _hoisted_41 = ["href"]

import { computed, nextTick, onMounted, onUnmounted, ref } from 'vue';
import { v4 as uuidv4 } from 'uuid';
import { useI18n } from '@/i18n';

import { useLoginForm } from '@/composables/login-form';

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'member-login',
  props: {
    employerUrl: { type: String, default: '' },
    providerUrl: { type: String, default: '' },
    agentsUrl: { type: String, default: '' },
    aemSiteIdentifier: { type: String, default: '' },
},
  setup(__props) {

const props = __props;



const { t } = useI18n();
const uuid = uuidv4();

const {
    selectedSwimlane,
    swimlaneOptions,
    showSwimlaneSelection,

    selectedRegion,
    regionOptions,
    showRegionSelection,

    username,
    usernameHasError,

    password,
    passwordHasError,
    passwordInputType,
    passwordVisibilityIcon,
    togglePasswordVisibility,

    loading,

    submissionAlert,

    login,

    forgotUsernameLink,
    forgotPasswordLink,
    registerLink,
} = useLoginForm({ aemSiteIdentifier: props.aemSiteIdentifier });

const otherLoginsToggle = ref<HTMLButtonElement>();
const otherLoginsMenu = ref<HTMLButtonElement>();
const employerLoginLink = ref<HTMLLinkElement>();
const providerLoginLink = ref<HTMLLinkElement>();
const agentsLoginLink = ref<HTMLLinkElement>();
const isOtherLoginsExpanded = ref<boolean>(false);

const hasOtherLogins = computed<boolean>(() => {
    return !!props.employerUrl || !!props.providerUrl || !!props.agentsUrl;
});

const otherLoginLinks = computed<HTMLLinkElement[]>(() => {
    return [employerLoginLink.value, providerLoginLink.value, agentsLoginLink.value]
        .filter((link) => !!link);
});

onMounted(() => {
    window.addEventListener('mousedown', onMousedownWindow, true);
});

onUnmounted(() => {
    window.removeEventListener('mousedown', onMousedownWindow, true);
});

function onMousedownWindow(event: MouseEvent) {
    if (
        !otherLoginsToggle.value || !otherLoginsMenu.value
        || otherLoginsToggle.value.contains(event.target as HTMLElement)
        || otherLoginsMenu.value.contains(event.target as HTMLElement)
    ) {
        return;
    }
    isOtherLoginsExpanded.value = false;
}

async function onClickOtherLoginsToggle() {
    isOtherLoginsExpanded.value = !isOtherLoginsExpanded.value;
    await nextTick();
    if (isOtherLoginsExpanded.value) {
        otherLoginLinks.value[0].focus();
    }
}

function onKeydownOtherLoginsToggle(event: KeyboardEvent) {
    if (event.key === 'ArrowDown') {
        event.preventDefault();
        onClickOtherLoginsToggle();
    } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
    } else if (event.key === 'Tab') {
        collapseDropdownIfNoFocus();
    }
}

async function onKeydownOtherLoginsMenu(event: KeyboardEvent) {
    if (!document.activeElement) return;
    let currentIndex = otherLoginLinks.value.indexOf(document.activeElement as HTMLLinkElement);
    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
        event.preventDefault();
        if (currentIndex < otherLoginLinks.value.length - 1) {
            currentIndex++;
        }
        otherLoginLinks.value[currentIndex].focus();
    } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
        event.preventDefault();
        if (currentIndex > 0) {
            currentIndex--;
        }
        otherLoginLinks.value[currentIndex].focus();
    } else if (event.key === 'Escape') {
        event.preventDefault();
        otherLoginsToggle.value?.focus();
        isOtherLoginsExpanded.value = false;
    } else if (event.key === 'Tab') {
        collapseDropdownIfNoFocus();
    }
}

async function collapseDropdownIfNoFocus() {
    await nextTick();
    await new Promise((resolve) => setTimeout(resolve, 0));
    if (
        !otherLoginsToggle.value?.contains(document.activeElement as HTMLElement)
        && !otherLoginsMenu.value?.contains(document.activeElement as HTMLElement)
    ) {
        isOtherLoginsExpanded.value = false;
    }
}


return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("form", {
    action: "javascript:void(0)",
    novalidate: "",
    class: _normalizeClass(["mhtk-login", {
            'mhtk-login--loading': _unref(loading),
        }]),
    "aria-busy": _unref(loading) ? 'true' : undefined,
    "data-test-ref": "member-login",
    onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_unref(login)()), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" Title "),
      _createElementVNode("h2", _hoisted_3, [
        _createElementVNode("strong", null, _toDisplayString(_unref(t)('login.title.memberLogin')), 1 /* TEXT */),
        _createElementVNode("span", {
          innerHTML: _unref(t)('login.title.myHealthToolkit')
        }, null, 8 /* PROPS */, _hoisted_4)
      ]),
      _createCommentVNode(" Other Logins Dropdown "),
      (_unref(hasOtherLogins))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("button", {
              id: 'other-logins-toggle-' + _unref(uuid),
              ref_key: "otherLoginsToggle",
              ref: otherLoginsToggle,
              class: "mhtk-login__dropdown-button",
              type: "button",
              "aria-haspopup": "menu",
              "aria-expanded": isOtherLoginsExpanded.value,
              "data-test-ref": "other-logins-toggle",
              onClick: onClickOtherLoginsToggle,
              onKeydown: onKeydownOtherLoginsToggle
            }, [
              _createTextVNode(_toDisplayString(_unref(t)('login.otherLogins.title')) + " ", 1 /* TEXT */),
              _hoisted_7
            ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_6),
            _createElementVNode("ul", {
              ref_key: "otherLoginsMenu",
              ref: otherLoginsMenu,
              class: _normalizeClass(["mhtk-login__dropdown-menu", {
                        'mhtk-login__dropdown-menu--show': isOtherLoginsExpanded.value
                    }]),
              role: "menu",
              "data-test-ref": "other-logins-menu",
              "aria-labelledby": 'other-logins-toggle-' + _unref(uuid),
              onKeydown: onKeydownOtherLoginsMenu
            }, [
              (__props.employerUrl)
                ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                    _createElementVNode("a", {
                      ref_key: "employerLoginLink",
                      ref: employerLoginLink,
                      role: "menuitem",
                      href: __props.employerUrl,
                      target: "_blank",
                      "data-test-ref": "employer-page-link"
                    }, [
                      _createTextVNode(_toDisplayString(_unref(t)('login.otherLogins.employer')), 1 /* TEXT */),
                      _hoisted_11
                    ], 8 /* PROPS */, _hoisted_10)
                  ]))
                : _createCommentVNode("v-if", true),
              (__props.providerUrl)
                ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                    _createElementVNode("a", {
                      ref_key: "providerLoginLink",
                      ref: providerLoginLink,
                      role: "menuitem",
                      href: __props.providerUrl,
                      target: "_blank",
                      "data-test-ref": "provider-page-link"
                    }, [
                      _createTextVNode(_toDisplayString(_unref(t)('login.otherLogins.provider')), 1 /* TEXT */),
                      _hoisted_14
                    ], 8 /* PROPS */, _hoisted_13)
                  ]))
                : _createCommentVNode("v-if", true),
              (__props.agentsUrl)
                ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                    _createElementVNode("a", {
                      ref_key: "agentsLoginLink",
                      ref: agentsLoginLink,
                      role: "menuitem",
                      href: __props.agentsUrl,
                      target: "_blank",
                      "data-test-ref": "agents-page-link"
                    }, [
                      _createTextVNode(_toDisplayString(_unref(t)('login.otherLogins.agents')), 1 /* TEXT */),
                      _hoisted_17
                    ], 8 /* PROPS */, _hoisted_16)
                  ]))
                : _createCommentVNode("v-if", true)
            ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_8)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createCommentVNode(" Submission Alert "),
    (_unref(submissionAlert))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass('mhtk-login__alert mhtk-login__alert--' + _unref(submissionAlert)?.variant),
          role: "alert",
          "aria-live": "polite",
          "data-test-ref": _unref(submissionAlert)?.testRef
        }, [
          _createElementVNode("span", {
            class: _normalizeClass({
                    'fa-solid fa-exclamation-triangle': _unref(submissionAlert)?.variant === 'warning',
                    'fa-solid fa-exclamation-circle': _unref(submissionAlert)?.variant === 'danger',
                }),
            "aria-hidden": "true"
          }, null, 2 /* CLASS */),
          _createVNode(_component_i18n_t, {
            keypath: _unref(submissionAlert).i18nKey
          }, {
            forgotUsername: _withCtx(() => [
              _createElementVNode("a", { href: _unref(forgotUsernameLink) }, _toDisplayString(_unref(t)('login.link.forgotYourUsername')), 9 /* TEXT, PROPS */, _hoisted_19)
            ]),
            forgotPassword: _withCtx(() => [
              _createElementVNode("a", { href: _unref(forgotPasswordLink) }, _toDisplayString(_unref(t)('login.link.forgotYourPassword')), 9 /* TEXT, PROPS */, _hoisted_20)
            ]),
            callSupport: _withCtx(() => [
              _createElementVNode("a", {
                href: _unref(t)('login.link.callSupportLink')
              }, _toDisplayString(_unref(t)('login.link.callSupport')), 9 /* TEXT, PROPS */, _hoisted_21)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["keypath"])
        ], 10 /* CLASS, PROPS */, _hoisted_18))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Swimlane "),
    (_unref(showSwimlaneSelection))
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("label", {
            for: _unref(uuid) + '-swimlane'
          }, _toDisplayString(_unref(t)('login.label.swimlane')), 9 /* TEXT, PROPS */, _hoisted_23),
          _withDirectives(_createElementVNode("select", {
            id: _unref(uuid) + '-swimlane',
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedSwimlane) ? (selectedSwimlane).value = $event : null)),
            type: "text"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(swimlaneOptions), (option) => {
              return (_openBlock(), _createElementBlock("option", {
                key: option.value ?? '',
                value: option.value
              }, _toDisplayString(option.text), 9 /* TEXT, PROPS */, _hoisted_25))
            }), 128 /* KEYED_FRAGMENT */))
          ], 8 /* PROPS */, _hoisted_24), [
            [_vModelSelect, _unref(selectedSwimlane)]
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Region "),
    (_unref(showRegionSelection))
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("label", {
            for: _unref(uuid) + '-region'
          }, _toDisplayString(_unref(t)('login.label.region')), 9 /* TEXT, PROPS */, _hoisted_27),
          _withDirectives(_createElementVNode("select", {
            id: _unref(uuid) + '-region',
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(selectedRegion) ? (selectedRegion).value = $event : null)),
            type: "text"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(regionOptions), (option) => {
              return (_openBlock(), _createElementBlock("option", {
                key: option.value ?? '',
                value: option.value
              }, _toDisplayString(option.text), 9 /* TEXT, PROPS */, _hoisted_29))
            }), 128 /* KEYED_FRAGMENT */))
          ], 8 /* PROPS */, _hoisted_28), [
            [_vModelSelect, _unref(selectedRegion)]
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Username "),
    _createElementVNode("div", {
      class: _normalizeClass(["mhtk-login__form-field", {
                'mhtk-login__form-field--error': _unref(usernameHasError)
            }]),
      "data-test-ref": "member-username-field"
    }, [
      _createElementVNode("label", {
        for: _unref(uuid) + '-username'
      }, _toDisplayString(_unref(t)('login.label.username')), 9 /* TEXT, PROPS */, _hoisted_30),
      _withDirectives(_createElementVNode("input", {
        id: _unref(uuid) + '-username',
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(username) ? (username).value = $event : null)),
        type: "text",
        "data-test-ref": "member-username-input",
        placeholder: _unref(t)('login.placeholder.enterUsername'),
        "aria-invalid": _unref(usernameHasError)
      }, null, 8 /* PROPS */, _hoisted_31), [
        [_vModelText, _unref(username)]
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("a", {
          href: _unref(forgotUsernameLink),
          "data-test-ref": "member-forgot-username-link"
        }, _toDisplayString(_unref(t)('login.link.forgotYourUsername')), 9 /* TEXT, PROPS */, _hoisted_33)
      ])
    ], 2 /* CLASS */),
    _createCommentVNode(" Password "),
    _createElementVNode("div", {
      class: _normalizeClass(["mhtk-login__form-field", {
                'mhtk-login__form-field--error': _unref(passwordHasError)
            }]),
      "data-test-ref": "member-password-field"
    }, [
      _createElementVNode("label", {
        for: _unref(uuid) + '-password'
      }, _toDisplayString(_unref(t)('login.label.password')), 9 /* TEXT, PROPS */, _hoisted_34),
      _createElementVNode("div", _hoisted_35, [
        _withDirectives(_createElementVNode("input", {
          id: _unref(uuid) + '-password',
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
          type: _unref(passwordInputType),
          "data-test-ref": "member-password-input",
          placeholder: _unref(t)('login.placeholder.enterPassword'),
          "aria-invalid": _unref(passwordHasError)
        }, null, 8 /* PROPS */, _hoisted_36), [
          [_vModelDynamic, _unref(password)]
        ]),
        _createElementVNode("button", {
          type: "button",
          "aria-label": _unref(t)('login.action.togglePasswordVisibility'),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(togglePasswordVisibility)()))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(_unref(passwordVisibilityIcon)),
            "aria-hidden": "true"
          }, null, 2 /* CLASS */)
        ], 8 /* PROPS */, _hoisted_37)
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("a", {
          href: _unref(forgotPasswordLink),
          "data-test-ref": "member-forgot-password-link"
        }, _toDisplayString(_unref(t)('login.link.forgotYourPassword')), 9 /* TEXT, PROPS */, _hoisted_39)
      ])
    ], 2 /* CLASS */),
    _createCommentVNode(" Login Button "),
    _createElementVNode("button", _hoisted_40, _toDisplayString(_unref(t)('login.action.logIn')), 1 /* TEXT */),
    _createCommentVNode(" Create Account Link "),
    _createElementVNode("p", null, [
      _createTextVNode(_toDisplayString(_unref(t)('login.label.newUser')) + " ", 1 /* TEXT */),
      _createElementVNode("a", {
        href: _unref(registerLink),
        "data-test-ref": "member-create-account-link"
      }, _toDisplayString(_unref(t)('login.link.createAccount')), 9 /* TEXT, PROPS */, _hoisted_41)
    ])
  ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_1))
}
}

})